// src/pages/GameSelectPage.jsx
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function GameSelectPage() {
  const navigate = useNavigate();
  const { roomCode } = useParams();

  return (
    <div style={{ padding: 40 }}>
      <h2>🎮 انتخاب بازی</h2>
      <div style={{ display: "flex", gap: 20 }}>
        <button onClick={() => navigate(`/chess/${roomCode}`)}>♟ شطرنج</button>
        <button onClick={() => alert("فعلاً پیاده‌سازی نشده")}>🎲 منچ</button>
        <button onClick={() => navigate(`/pasoor/${roomCode}`)}>🃏 پاسور</button>
      </div>
    </div>
  );
}
